import type { ReactNode } from "react";

import type { StructureModalTabId } from "./admin-structure-modal-tabs.config";
import { useAdminStructureGeneralDataFormContext } from "./useAdminStructureGeneralDataFormContext";
import { AdminStructureOpenPitGeometryFormProvider } from "./AdminStructureOpenPitGeometryFormProvider";
import { AdminStructureOpenPitSectorsField } from "./AdminStructureOpenPitSectorsField";

type AdminStructureDetailModalOpenPitShellProps = {
  children: ReactNode;
  activeTab: StructureModalTabId;
};

export const AdminStructureDetailModalOpenPitShell = ({
  children,
  activeTab,
}: AdminStructureDetailModalOpenPitShellProps) => {
  const { detail, canWrite, form } = useAdminStructureGeneralDataFormContext();
  const draftType = form.watch("type");
  const typePersisted = Boolean(detail.type);
  const effectiveType = detail.type ?? draftType;

  if (effectiveType !== "openPit") {
    return children;
  }

  return (
    <AdminStructureOpenPitGeometryFormProvider
      detail={detail}
      canWrite={canWrite}
      typePersisted={typePersisted}
    >
      <div className="flex flex-col gap-4">
        {activeTab === "geometry" ? (
          <div className="w-full max-w-[550px] shrink-0">
            <AdminStructureOpenPitSectorsField />
          </div>
        ) : null}
        {children}
      </div>
    </AdminStructureOpenPitGeometryFormProvider>
  );
};
